import PropTypes from 'prop-types';

const AddressSection = ({
    streetAddress,
    valuationAddress,
}) => {

    return (
        <div>
            <table width="100%">
                <tbody>
                    <tr>
                        <td style={{ paddingBottom: 8 }}>
                            <span className="property-label">Street Address:</span> {streetAddress}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span className="property-label">Valuation Address:</span> {valuationAddress}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

};

AddressSection.propTypes = {
    streetAddress: PropTypes.string,
    valuationAddress: PropTypes.string,
};

export default AddressSection;